module.exports = __webpack_public_path__ + "b32ad88d3b4430fadf32da6db2f146ab.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/quiz-1.png
// module id = 1126
// module chunks = 0